import { useMutation } from "@tanstack/react-query";
import {
  type ChangePasswordRequest,
  putUsersChangePassword,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useChangePasswordMutation = ({ onSuccess, onError }: Props = {}) =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: ChangePasswordRequest) => putUsersChangePassword(data),
    ),
    onSuccess,
    onError,
  });
